module.exports = __webpack_public_path__ + "static/media/LazyAz_web3_preview.86652381.jpg";